import {
	ConfluenceTemplatesUnifiedRelayPageTemplate,
	ConfluenceTemplatesUnifiedRelayPageTemplateProps,
} from '@/templates/software/confluence/templates/confluence-templates-page/src/relay/contentful-relay/confluence-templates-unified-contentful-relay-page.template';

export type ConfluenceTemplateSearchRelayPageProps =
	ConfluenceTemplatesUnifiedRelayPageTemplateProps;

export const ConfluenceTemplateSearchRelayPage = ({
	queryRef,
}: ConfluenceTemplateSearchRelayPageProps) => {
	return <ConfluenceTemplatesUnifiedRelayPageTemplate queryRef={queryRef} />;
};
